export class LocalStorageKeyCollection {
    static retailFilterStorageKey = "Retail.Filter.tmp.{0}";
    static retailDetailStorageKey = "Retail.Detail.tmp.{0}";
    
    static accountLoginStorage = "account.login.storage";
    static configCache = "configList";
}